import { defineMessages } from '@jutro/locale';

export default defineMessages({
    makeChanges: {
        id: 'ml.endorsement.ho.views.propertyDetails.Make Changes',
        defaultMessage: 'Make Changes'
    },
    propertyDetails: {
        id: 'ml.endorsement.ho.views.propertyDetails.Property Details',
        defaultMessage: 'Property Details'
    },
    savingEndorsementDetails: {
        id: 'ml.endorsement.ho.views.propertyDetails.Saving endorsement details...',
        defaultMessage: 'Saving endorsement details...'
    },
    unableToSaveEndorsement: {
        id: 'ml.endorsement.ho.views.propertyDetails.Unable to save endorsement',
        defaultMessage: 'Unable to save endorsement'
    },
    errorWhenSavingEndorsement: {
        id: 'ml.endorsement.ho.views.propertyDetails.An error occurred while attempting to save endorsement.',
        defaultMessage: 'An error occurred while attempting to save endorsement.'
    },
    somethingWentWrong: {
        id: 'ml.endorsement.ho.views.propertyDetails.Something went wrong processing home details',
        defaultMessage: 'Something went wrong processing home details'
    },
    pleaseTryAgain: {
        id: 'ml.endorsement.ho.views.propertyDetails.Please try again.',
        defaultMessage: 'Please try again.'
    },
    nextLabel: {
        id: 'ml.endorsement.ho.views.propertyDetails.We\'ll check if additional changes are needed next',
        defaultMessage: 'We\'ll check if {additionalChangesAreNeeded} next'
    },
    additionalChangesAreNeeded: {
        id: 'ml.endorsement.ho.views.propertyDetails.additional changes are needed',
        defaultMessage: 'additional changes are needed'
    },
    updatedPropertyDetails: {
        id: 'ml.endorsement.ho.views.propertyDetails.Updated Property Details',
        defaultMessage: 'Updated Property Details'
    },
    detailsAboutYourHome: {
        id: 'ml.endorsement.ho.views.propertyDetails.Details about your home',
        defaultMessage: 'Details about your home'
    }
});
